export default __webpack_public_path__ + "static/media/cloud.74e396ee.svg";